import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isOrderCreatingSelector, processActions } from '@/models/process';
import { scrollToTop } from '@/libs/helpers/utils';
import { goNextStep } from '@/models/steps/goNextStep';
import { isLastStepSelector } from '@/models/steps/selectors';
import { useInsuranceStyles } from '../styles';
import { UserTermsBlock } from '../UserTermsBlock';
import { ContinueButton } from '../ContinueButton';
import { DetailsOverview } from './DetailsOverview';
import { OfferBlock } from './OfferBlock';
export const DetailsTab = () => {
    const insuranceClasses = useInsuranceStyles();
    const dispatch = useDispatch();
    const isOrderCreating = useSelector(isOrderCreatingSelector);
    const isLastStep = useSelector(isLastStepSelector);
    useEffect(() => {
        dispatch(processActions.setIsLoadingPayment(false));
        scrollToTop();
    }, []);
    const onContinue = () => {
        dispatch(goNextStep());
    };
    return (_jsxs(_Fragment, { children: [_jsx(DetailsOverview, {}), _jsx(OfferBlock, {}), _jsx("div", { className: insuranceClasses.buttons, children: _jsx(ContinueButton, { onClick: onContinue, isLoading: isLastStep && isOrderCreating }) }), _jsx(UserTermsBlock, {})] }));
};
